import type { Theme } from "@mui/material/styles";
import { makeStyles, createStyles } from "@mui/styles";

export const PaginationStyles = makeStyles((theme: Theme) =>
  createStyles({
    paginationContainer: {
      padding: "30px 0px 60px 0px",
    },
    pagination: {
      "& .MuiPaginationItem-icon": {
        height: "40px",
      },
    },
    paginationXS: {},
    controls: {
      width: "80px",
      height: "50px",
      borderRadius: "6px",
    },
    disabledButton: {
      height: "50px",
      borderRadius: "0px",
      opacity: ".3",
    },
    select: {
      width: "30px",
      height: "30px",
      borderRadius: "50%",
      backgroundColor: theme.palette.secondary.main,
      color: "#fff",
      // fontSize: "20px",
      // paddingBottom: "15px",
      // paddingRight: "33px",
      "&	.MuiSelect-standard": {
        display: "flex",
        paddingLeft: "24%",
        justifyContent: "center",
      },
      "& .MuiSelect-iconStandard": {
        padding: "0px",
        margin: "0px",
        border: "1px solid red",
        left: 0,
        display: "none",
      },
    },
    text: {
      color: "RGB(209, 123, 130)",
      fontSize: "20px",
    },
    currentPage: {
      fontSize: "24px",
    },
    stack: {
      padding: "30px",
      [theme.breakpoints.down(434)]: {
        padding: "30px 0px",
      },
    },
    menuPaper: {
      maxHeight: 300,
    },
  }),
);
